module.exports = __webpack_public_path__ + "media/images/gallery/border_on-b2e97e7f6db8c2931a88a1168fd9d846.gif";